<template>
  <div :class="containerClass">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { messageTypes, MessageType } from './constants'

// eslint-disable-next-line no-undef
defineOptions({
  name: 'SfModalMessage',
})

interface Props {
  variant?: MessageType
}

const props = withDefaults(defineProps<Props>(), {
  variant: messageTypes.info,
})

const containerClass = computed(() => {
  return {
    'sf-modal-message': true,
    [`sf-modal-message-${props.variant}`]: true,
  }
})
</script>
